const state = {
    appliedFiltersCount: null,
};

export default state;